import { Component, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectAccountService } from '@core/services/select-account.service';
import { labels } from '../../../../messages';

@Component({
    selector: 'select-account',
    templateUrl: 'select-account.component.html',
    styleUrls: ['./select-account.component.scss'],
})

export class SelectAccountComponent implements OnDestroy {
   messageValue: string = 'Change Detected';
   @Output() messageEvent = new EventEmitter<string>();
    private subscription: Subscription;
    churchAccounts= [];
    message = false;
    labelMessages = labels;
    churchAccountFoundAndSelected:boolean=false;
    isModalOpened:boolean=false;
    isChurchAccountSelected:boolean=false;
    selectedChurchAccount = '';
    loggedInUserContactId = '';
    selectedAccountName = '';
    selectedAccountId = '';
    selectedIntacctId = '';
    selectedAccountType = '';
    purchaserDetails;
    status: any;
    isAccountSelected:boolean=false;

    constructor(private selectAccountService: SelectAccountService) { 
      //  subscribe to alert messages
        this.subscription = selectAccountService.getMessage()
        .subscribe(
            message => { 
              this.churchAccounts = message.text;
              if(this.churchAccounts.length > 0) {
                this.status = 'InProgress';
                this.messageEvent.emit(this.messageValue);
              }
            setTimeout(function() {
               this.message = false;            
            }.bind(this), 20000);

        });
    }

    
    closeMessageBox() {
        this.message = false;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

 onChurchSelectionChange(accountId){
    this.selectedChurchAccount = accountId;
    this.isChurchAccountSelected=true;
    this.isAccountSelected=true;
  }
  
  setSelectedAccount() {
    if(this.isChurchAccountSelected && this.selectedChurchAccount != '') {      
       let index = this.churchAccounts.findIndex(church => church.accountId == this.selectedChurchAccount);
       if(index != -1) {
        this.selectedAccountName = this.churchAccounts[index].accountName;
        this.selectedAccountId = this.churchAccounts[index].accountId;
        this.selectedIntacctId = this.churchAccounts[index].intactId
        this.selectedAccountType = 'Church';
        this.setAccountInStorage();

       }
    } else {
        this.setAccountInStorage();

    }
    this.churchAccounts = [];
  }

  setSelfAccount(){
    this.isChurchAccountSelected=false;
    this.purchaserDetails = JSON.parse(localStorage.getItem('profile'));
    if(this.purchaserDetails != null) {
        this.selectedAccountName = 'Household';
        this.selectedAccountId = this.purchaserDetails.AccountId;  
        this.selectedIntacctId =  this.purchaserDetails.IntacctID__c;
        this.selectedAccountType = 'Household';   
        let selectedAccountObj = {
            accountName: this.selectedAccountName,
            accountId: this.selectedAccountId,
            intacctId: this.purchaserDetails.IntacctID__c,
            type: 'Household'
        }
        localStorage.setItem('selectedAccount', JSON.stringify(selectedAccountObj));
        this.status = 'Completed';
        this.messageEvent.emit(this.messageValue);
        this.churchAccounts = [];
    }
        
  }

  onSelfAccountSelection(){
    this.isChurchAccountSelected=false;
    this.isAccountSelected=true;
    this.purchaserDetails = JSON.parse(localStorage.getItem('profile'));
    if(this.purchaserDetails != null) {
        this.selectedAccountName = 'Household';
        this.selectedAccountId = this.purchaserDetails.AccountId;  
        this.selectedIntacctId =  this.purchaserDetails.IntacctID__c;
        this.selectedAccountType = 'Household';  
    }
  }

  setAccountInStorage() {
    let selectedAccountObj = {
        accountName: this.selectedAccountName,
        accountId: this.selectedAccountId,
        intacctId: this.selectedIntacctId,
        type: this.selectedAccountType
    }
    localStorage.setItem('selectedAccount', JSON.stringify(selectedAccountObj));
    this.status = 'Completed';
    this.messageEvent.emit(this.messageValue);
  }
    
}